import {
  Box,
  Button,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@material-ui/core'
import { FlexHorizontal, Spacer } from '@vestaboard/installables'

import { Alert } from '@material-ui/lab'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp'
import { MessageTemplateTabs } from '../components/Tabs'
import React from 'react'
import { TruncatedId } from '../../truncated-id'
import { useHistory } from 'react-router'
import { useListTemplateCategories } from '../hooks/useListTemplateCategories'

export const ListCategories = () => {
  const history = useHistory()
  const [sortDirection, setSortDirection] = React.useState<'asc' | 'desc'>('asc')
  const [sortField, setSortField] = React.useState<'id' | 'title'>('title')
  const { loading, error, data } = useListTemplateCategories({
    input: {}
  })

  return (
    <Box>
      <FlexHorizontal spaceBetween>
        <Typography variant='h4'>Template Categories</Typography>
        <Button onClick={() => history.push('/message-templates/category/create')} variant='contained' color='primary'>
          Create Template Category
        </Button>
      </FlexHorizontal>
      <Box>
        <Spacer size='extraLarge' />
        <MessageTemplateTabs activeTab='categories' />
      </Box>
      <Spacer size='large' />
      {loading ? (
        <CircularProgress />
      ) : error ? (
        <Alert severity='error'>There was an error loading the template categories</Alert>
      ) : !data?.listTemplateCategories.templateCategories.length ? (
        <Alert severity='info'>There are no template categories</Alert>
      ) : (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell
                  style={{ width: 360, cursor: 'pointer' }}
                  onClick={() => {
                    setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc')
                    setSortField('id')
                  }}>
                  ID
                  {sortField === 'id' ? (
                    sortDirection === 'asc' ? (
                      <KeyboardArrowUpIcon />
                    ) : (
                      <KeyboardArrowDownIcon />
                    )
                  ) : null}
                </TableCell>
                <TableCell
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc')
                    setSortField('title')
                  }}>
                  Title
                  {sortField === 'title' ? (
                    sortDirection === 'asc' ? (
                      <KeyboardArrowUpIcon />
                    ) : (
                      <KeyboardArrowDownIcon />
                    )
                  ) : null}
                </TableCell>
                <TableCell style={{ width: 150 }}></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data?.listTemplateCategories.templateCategories
                .sort((a, b) => {
                  if (sortField === 'title') {
                    return sortDirection === 'asc' ? a.title.localeCompare(b.title) : b.title.localeCompare(a.title)
                  }
                  return sortDirection === 'asc' ? a.id.localeCompare(b.id) : b.id.localeCompare(a.id)
                })
                .map(colorTemplate => (
                  <TableRow key={colorTemplate.id}>
                    <TableCell>
                      <TruncatedId
                        value={colorTemplate.id}
                        full
                        path={`/message-templates?categoryId=${colorTemplate.id}`}
                      />
                    </TableCell>
                    <TableCell>{colorTemplate.title}</TableCell>
                    <TableCell>
                      <FlexHorizontal>
                        <Button
                          variant='contained'
                          color='default'
                          onClick={() => history.push(`/message-templates/category/${colorTemplate.id}`)}>
                          Edit
                        </Button>
                        <div style={{ width: 12 }} />
                        <Button
                          variant='contained'
                          color='default'
                          onClick={() => history.push(`/message-templates/?categoryId=${colorTemplate.id}`)}>
                          Messages
                        </Button>
                      </FlexHorizontal>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  )
}
